import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><path d=\"M633.423 512.225l364.938-364.931A86.022 86.022 0 1 0 876.712 25.639L511.775 390.587 146.835 25.639A86.018 86.018 0 0 0 25.19 147.288l364.94 364.937L25.188 877.16a86.02 86.02 0 0 0 121.647 121.65l364.94-364.945L876.712 998.81a86.02 86.02 0 0 0 121.649-121.65z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol